import PageRenderer from "../components/PageRenderer";

const Spendenziel = () => <PageRenderer pageName="Spendenziel" analyticsPath="/spendenziel" />;

export default Spendenziel;
